<template>

    
    
    <div class="links" v-if="dataLoaded && coursesOnDemandLoaded && creationOptionsLoaded">

        <Loader v-if="isDownloading" class="loader-is-downloading" />

        <div class="new-and-filter">
            <h3>Enlaces para gestionar</h3>
            <div class="new-and-filter__btns">
                <button class="create-new" @click.stop="modalAddLink.active = true"><i class="material-icons">add_circle</i>Nuevo enlace</button>
            </div>
        </div>

        <div ref="table" class="table-pagination">
            <div class="table__container">
                <table class="table">
                    <thead class="table__head">
                        <tr class="table__head__row">
                            <th class="table__head__row__title">DESCRIPCIÓN</th>
                            <th class="table__head__row__link">ENLACE</th>
                            <th class="table__head__row__course">CURSO</th>
                            <th class="table__head__row__options"></th>
                        </tr>
                    </thead>
                    <tbody class="table__body">
                        <tr td="table__body__row" v-for="(row,index) in links" :key="index">
                            <td class="table__body__row__title" @mouseover="row.titleTooltip = true" @mouseleave="row.titleTooltip = false">
                                {{row.description}}
                            </td>
                            <td class="table__body__row__link" @click.stop="copyToClipboard(row.value)">
                                <span>{{row.value}}</span>
                                <i class="material-icons">content_copy</i>
                            </td>
                            <td class="table__body__row__course" >{{row.courseCode}}</td>
                            <td class="table__body__row__options" @click.stop="modalOptions == row.id ? modalOptions = null : modalOptions = row.id">
                                <i class="material-icons">more_vert</i>
                                <!-- Más opciones -->
                            </td>
                            <div class="table__modal-options" v-if="modalOptions == row.id" @click.stop="''">
                                <div @click.stop="openDeactivateLinkModal(row.id, row.description, row.courseCode)">
                                    <i class="material-icons">
                                        link_off
                                    </i>
                                    Desactivar enlace
                                </div>

                                <div @click.stop="openEditLinkModal(row)">
                                    <i class="material-icons">
                                        edit
                                    </i>
                                    Editar enlace
                                </div>

                                <div @click.stop="getShortLink(row)">
                                    <i class="material-icons" v-if="!row.loadingShortLink">
                                        link
                                    </i>
                                    <div class="loading-link" v-else>
                                        <div class="loading-link__dot"></div>
                                        <div class="loading-link__dot"></div>
                                        <div class="loading-link__dot"></div>
                                    </div>
                                    {{ row.loadingShortLink ? 'Obteniendo enlace corto...' : 'Obtener enlace corto' }}
                                </div>


                            </div>
                            
        
                        </tr>
                    </tbody>
                    
                </table>
                <div v-if="!links.length" style="width:1150px;padding:20px 0 20px 0;text-align:center">No hay resultados para mostrar...</div>
            </div>
            <div class="pagination" v-if="totalResults">
                <button class="prev-next" @click.stop="selectPage('prev')" :disabled="params.page == 0"><i class="material-icons">arrow_back</i><span>Anterior</span> </button>
                <div class="page"><span>{{ formattedPage }}</span>{{ formattedPages }}</div>
                <button class="prev-next" @click.stop="selectPage('next')" :disabled="params.page+1 == pages"><span>Siguiente</span> <i class="material-icons">arrow_forward</i></button>
            </div>
        </div>

        <Modal :isOpen="modalAddLink.active" @close="handleModalClose">
            <div class="modal-add-link">
                <h4>{{ modalAddLink.isEditing ? 'Editar enlace' : 'Nuevo enlace' }}</h4>
                <div class="modal-add-link__box">
                    <h5>DESCRIPCIÓN</h5>
                    <p>{{ modalAddLink.isEditing ? 'Actualiza la descripción del enlace:' : 'Ingresa una descripción corta para el nuevo enlace:' }}</p>
                    <Input 
                        v-model="modalAddLink.description"
                        label="Descripción"
                        maxlength="50"
                        placeholder="Ejemplo: Campaña redes sociales"
                    />
                </div>
                <!-- Solo muestra el campo "NOMBRE" al agregar un nuevo enlace -->
                <div class="modal-add-link__box" :class="{ 'editing': modalAddLink.isEditing }">
                    <h5>NOMBRE</h5>
                    <p>Asigna un nombre al nuevo enlace. Este nombre se añadirá al final de la URL y formará parte de ella:</p>
                    <div class="disclaimer">
                        <i class="material-icons">info</i>
                        <span>El nombre del enlace puede incluir solo letras, números y guiones medios.</span>
                    </div>
                    <Input 
                        type="link"
                        v-model="modalAddLink.value"
                        label="Enlace"
                        maxlength="50"
                        placeholder="Ejemplo: link-redes-sociales"
                        :isError="existingLink"
                        errorMessage="Ya existe un enlace con este valor"
                        @input="checkLinkText($event)"
                        :labelBeforeText="creationOptions.urlBase"
                        :disabled="modalAddLink.isEditing"
                    />
                </div>
                <div class="modal-add-link__box">
                    <h5>CURSO</h5>
                    <p>Selecciona el curso al que quieres asociar este enlace:</p>
                    <!-- valueLabel if editing show courseCode -->
                    <!-- <Select 
                        v-model="modalAddLink.targetId"
                        label="Curso"
                        valueProp="id"
                        :valueLabel="modalAddLink.isEditing ? modalAddLink.courseCode : 'name'"
                        valueLabel="name"
                        :values="coursesOnDemand"
                        :isDropdown="true"
                    /> -->
                    <Select 
                        v-model="modalAddLink.targetId"
                        label="Curso"
                        valueProp="id"
                        valueLabel="name"
                        :values="coursesOnDemand"
                        :isDropdown="true"
                    />
                </div>
                <div class="buttons">
                    <button @click.stop="handleModalClose">Cancelar</button>
                    <button 
                        @click.stop="modalAddLink.isEditing ? editLink() : postLink()" 
                        :disabled="isModalButtonDisabled"
                        class="button__forward"
                    >
                        Guardar<i class="material-icons">arrow_forward</i>
                    </button>
                </div>
            </div>
        </Modal>



         <Modal :isOpen="modalDeactivateLink.active" @close="modalDeactivateLink.active = false">
            <div class="modal-body modal-deactivate-link">      
                <h4>¿Deseas <strong>desactivar el enlace</strong><br/>
                     <span>{{modalDeactivateLink.description}}</span> para el curso <span>{{modalDeactivateLink.courseCode}}</span>?</h4>
                <p>El enlace dejará de funcionar y no podrás revertir esta acción.</p>
                <div class="buttons">
                    <button @click.stop="modalDeactivateLink.active = false" class="modal-body__cancel">No, volver</button>
                    <button @click.stop="deactivateLink(modalDeactivateLink.id)" :disabled="modalDeactivateLinkLoading" class="button__forward">
                        Si, desactivar
                    </button>
                </div>
            </div>
        </Modal>

        <!-- Modal de confirmación -->
        <Modal :isOpen="confirmCancelModal" @close="confirmCancelModal = false">
            <div class="modal-body modal-body--confirm-cancel">
                <h4>¿Deseas <strong>cancelar</strong> {{ modalAddLink.isEditing ? 'la edición de este enlace' : 'la creación de este nuevo enlace' }}?</h4>
                <p>
                    Se perderá toda la información que has {{ modalAddLink.isEditing ? 'modificado' : 'cargado' }}.<br/>
                    Esta acción no se puede deshacer.
                </p>
                <div class="buttons">
                    <button @click.stop="confirmCancelModal = false" class="buttons__cancel">No, volver</button>
                    <button @click.stop="confirmCancel()">Sí, cancelar</button>
                </div>
            </div>
        </Modal>



        
    </div>
    <Loader v-else />

</template>

<script>
import { inject, onMounted, onBeforeUnmount, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/Modal.vue';
import Input from '@/components/Input.vue';
import Select from '@/components/Inputs/Select.vue';

export default {
    components: {
        Loader,
        Modal,
        Input,
        Select,
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const formatDate = inject('formatDate');
        const copyToClipboard = inject('copyToClipboard');
        const userData = computed(() => store.getters.manageUser_user);
        const creationOptions = ref();
        const creationOptionsLoaded = ref(false);
        const coursesOnDemand = ref();
        const coursesOnDemandLoaded = ref(false);   
        const modalOptions = ref(null)
        const table = ref(null)
        const dataLoaded = ref(false);
        const links = ref();
        const params = ref({
            page: 0,
            rows: 5,
            status: 'ALL',
            forgeUserId: '',
            country: 0,
        })
        const totalResults = ref();
        const remainResults = ref();
        const pages = ref();

        const formattedPage = computed(() => {
            return 'Página ' + (params.value.page + 1 < 10 ? '0' + (params.value.page + 1) : params.value.page + 1);
        });

        const formattedPages = computed(() => {
            return ' / ' + (pages.value < 10 ? '0' + pages.value : pages.value);
        });


        const modalAddLink = ref({
            active: false,
            description: '',
            value: '',
            targetId: '',
            isEditing: false,
            id: null,
            // courseCode: null,
        });

        const confirmCancelModal = ref(false);
        
        const modalAddLinkLoading = ref(false);

        const existingLink = ref(false);

        const modalDeactivateLink = ref({
            active: false,
            id: null,
            description: null,
            courseCode: null,
        })
        const modalDeactivateLinkLoading = ref(false);


        async function openDeactivateLinkModal(id, description, courseCode){
            modalDeactivateLink.value = { active: true, id: id, description: description, courseCode: courseCode }
        }

        function openEditLinkModal(row) {
            const course = coursesOnDemand.value.find(course => course.code === row.courseCode);
            modalAddLink.value = {
                active: true,
                description: row.description,
                value: row.value.replace(creationOptions.value.urlBase, ''),
                targetId: course ? course.id : null, // Asigna el id del curso
                isEditing: true,
                id: row.id,
            };
        }


        async function getShortLink(row) {
            if (row.shortValue) {
                copyToClipboard(row.shortValue);
            } else {
                row.loadingShortLink = true; // Set loader for the current row
                try {
                    let req = await store.dispatch('links_getShortUrl', row.id);
                    row.shortValue = req.data.value;
                    copyToClipboard(row.shortValue);
                } catch (error) {
                    console.log(error);
                    store.dispatch('notifications_create', { text: 'Error al intentar obtener el enlace corto' });
                } finally {
                    row.loadingShortLink = false; // Remove loader for the current row
                }
            }
        }




        // checklinktext must only accept numbers, letters and hyphens
        function checkLinkText(e){
            let value = e.target.value;
            let regex = /^[a-zA-Z0-9-]*$/;
            // replace all characters that are not numbers, letters or hyphens
            if(!regex.test(value)){
                e.target.value = value.replace(/[^a-zA-Z0-9-]/g, '');
            }
            existingLink.value = false;
        }


        async function handleModalClose() {
            // modalAddLink.description || modalAddLink.value ? confirmCancelModal = true : modalAddLink.active = false
            if (modalAddLink.value.description || modalAddLink.value.value || modalAddLink.value.targetId) {
                confirmCancelModal.value = true;
            } else {
                modalAddLink.value.active = false;
                modalAddLink.value.isEditing = false;
            }
        }


        function cleanModalFields(){
            modalAddLink.value = {
                active: false,
                description: '',
                value: '',
                targetId: '',
                isEditing: false,
                id: null,
            };
        }



        async function getCreationOptions() {
            try {
                let req = await store.dispatch('links_getCreationOptions');
                creationOptions.value = req.data;
                creationOptionsLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al cargar opciones de filtros' });
            }
        }

        async function getCoursesOnDemand(){
            try {
                let req = await store.dispatch('links_getCoursesOnDemand');
                coursesOnDemand.value = req.data;
                coursesOnDemandLoaded.value = true;                
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al cargar opciones de filtros' });
            }
        }

        async function getLinks() {
            try {
                dataLoaded.value = false;
                let req = await store.dispatch('links_getLinks', params.value);
                links.value = req.data.data.map(row => ({
                    ...row,
                    loadingShortLink: false // Add this line to initialize loading state
                }));
                totalResults.value = req.data.totalResults;
                remainResults.value = req.data.totalResults - (params.value.page * params.value.rows);
                pages.value = Math.ceil(req.data.totalResults / params.value.rows);
                dataLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al obtener los datos' });
            }
        }


        async function postLink(){
            modalAddLinkLoading.value = true;
            const data = {
                description: modalAddLink.value.description,
                value: modalAddLink.value.value,
                targetId: modalAddLink.value.targetId,
                code: modalAddLink.value.value,
            };
            try {
                await store.dispatch('links_postLink', data);
                modalAddLink.value.active = false;
                modalAddLink.value.isEditing = false;
                cleanModalFields();
                getLinks();
            } catch (error) {
                console.log(error);
                if(error.response.status == 400 && error.response.data == 'EXISTING_LINK'){
                    existingLink.value = true;
                } else {
                    store.dispatch('notifications_create', { text: 'Error al intentar agregar el enlace' });
                }
            } finally {
                modalAddLinkLoading.value = false;
            }
        }

        const isModalButtonDisabled = computed(() => {
            if (modalAddLinkLoading.value) return true;
            if (modalAddLink.value.isEditing) {
                return !modalAddLink.value.description || !modalAddLink.value.targetId;
            } else {
                return (
                    !modalAddLink.value.description ||
                    !modalAddLink.value.value ||
                    !modalAddLink.value.targetId ||
                    existingLink.value
                );
            }
        });



        async function editLink() {
            modalAddLinkLoading.value = true;
            const data = {
                id: modalAddLink.value.id,
                description: modalAddLink.value.description,
                targetId: modalAddLink.value.targetId,
            };
            try {
                await store.dispatch('links_editLink', data);
                modalAddLink.value.active = false;
                modalAddLink.value.isEditing = false;
                cleanModalFields();
                getLinks();
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: 'Error al intentar editar el enlace' });
            } finally {
                modalAddLinkLoading.value = false;
            }
        }


        async function deactivateLink(id){
            try {
                await store.dispatch('links_deactivateLink',id);
                getLinks();
                modalDeactivateLink.value.active = false;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create',{text: 'Error al intentar desactivar el enlace'});
                modalDeactivateLink.value.active = false;
            }
        }


        function selectPage(prevNext){
            if(prevNext == 'next') params.value.page++;
            else if(prevNext == 'prev') params.value.page--;
            getLinks()
        }


        
        const closeModalOptions = (e)=> { 
            if(!e.target.matches('.table__modal-options')){
                modalOptions.value = null;
            }
        }

        function confirmCancel() {
            modalAddLink.value.active = false;
            modalAddLink.value.isEditing = false;
            cleanModalFields();
            confirmCancelModal.value = false;
        }



        onMounted(()=>{
            getLinks();
            getCoursesOnDemand();
            getCreationOptions();
            document.addEventListener('click', closeModalOptions);
        })
        onBeforeUnmount(()=>{
            document.removeEventListener('click', closeModalOptions);

        })

        return{
            router,
            links,
            formatDate,
            copyToClipboard,
            userData,
            dataLoaded,
            coursesOnDemand,
            coursesOnDemandLoaded,
            modalOptions,
            modalAddLink,
            modalAddLinkLoading,
            modalDeactivateLink,
            openDeactivateLinkModal,
            modalDeactivateLinkLoading,
            getLinks,
            postLink,
            deactivateLink,
            cleanModalFields,
            pages,
            params,
            totalResults,
            selectPage,
            table,
            formattedPage,
            formattedPages,
            existingLink,
            checkLinkText,
            getCreationOptions,
            creationOptions,
            creationOptionsLoaded,
            confirmCancelModal,
            confirmCancel,
            openEditLinkModal,
            editLink,
            isModalButtonDisabled,
            handleModalClose,
            getShortLink,
        }
    },
}
</script>

<style lang="scss">
@import '@/styles/main.scss';
.table__modal-options{
    position: absolute;
    // top: 50px;
    right: 2px;
    min-width: 245px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 8000;
    >div{
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        &:hover{
            background: rgba(189, 228, 228, 0.5);
        }
    }

    .disabled {
        cursor: not-allowed;
        opacity: 0.5;
    
    }
}

.links{
    box-sizing: border-box;
    .new-and-filter{
        position: relative;
        min-height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media screen and (max-width: 750px) {
            flex-direction: column;
            gap: 12px;
        }
        h3{
            font-size: 20px;
        }
        &__btns{
            display: flex;
            gap: 16px;
            @media screen and (max-width: 750px) {
                padding-bottom: 16px;
                max-width: 100%;
                overflow-x: auto;
            }
            button{
                @include icon-and-text-container;
                font-size: 12px;
                &.create-new{
                    margin-right: 8px;
                    color: $green;
                    font-weight: 600;
                    .material-icons{
                        font-size: 15px;
                        padding-bottom: 2px;
                    }
                }
                &.open-filters{
                    border: 1px solid;
                    border-radius: 16px;
                    padding: 6px 18px;
                    font-weight: 400;
                    gap: 18px;
                    .material-icons{
                        font-size: 18px;
                    }
                }
            }
        }
        
    }

    .table-pagination {
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }
    @media(max-width:980px) {
        .table__container {
            overflow-x: auto;
        }
    }
    .table {
        width: 100%;
        position: relative;
        margin-top: 8px;
        padding: 16px;
        padding-bottom: 0;

        th, td {
            padding: 14px;
        }

        &__head {
            
            
            &__row {
                th {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-weight: 600;
                    font-size: 12px;
                    text-align: left;
                    
                    &.table__head__row__options {
                        padding-right: 0;
                        padding-left: 0;
                    }
                    &.table__head__row__title {
                        padding-left: 0;
                    }     
                }
            }
        }

        &__body {
            tr {
                td {
                    // max-width: 210px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 13px;
                    text-align: left;
                    border-bottom: 1px solid #eee;

                    &.table__body__row__title {
                        font-weight: 600;
                        font-size: 13px;
                        padding-left: 0;
                    }

                    &.table__body__row__link {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        cursor: pointer;
                        font-weight: 600;
                        // max-width: 300px;
                        // ellipsis
                        span {
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            max-width: 480px;
                        }

                        .material-icons{
                            color: $green;
                            font-size: 16px;
                        }
                        // span {
                        //     // overflow: hidden;
                        //     // white-space: nowrap;
                        //     // text-overflow: ellipsis;
                        //     // max-width: 400px;
                        //     max-width: 600px;
                        //     text-wrap: wrap;
                        // }
                    }


                    &.table__body__row__options {
                        // width: 50px;
                        font-size: 12px;
                        font-weight: 600;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
            }
        }

    }
    .pagination{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 24px 16px;
        .prev-next{
            @include icon-and-text-container;
            font-size: 15px;
            font-weight: 600;
            color: $green;
            line-height: 20px;
            &:disabled{
                cursor: default;
            }
            .material-icons{
                font-size: 20px;
            }
        }
        .page{
            font-size: 15px;
            font-weight: 400;
            span{
                font-weight: 700;
            }
        }
    }
}
.modal-add-link, .modal-deactivate-link, .modal-body {
    max-width: 800px;
    width: 100%;
    position: relative;
    // padding: 42px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    // background: #FFFFFF;
    // box-shadow: 5px 5px 35px rgba(217, 217, 217, 0.5);
    // border-radius: 10px;
    .close{
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
    }
    h4{
        padding-bottom: 4px;
        margin-top: -6px;
        font-weight: 700;
        font-size: 16px;
    }
    span{
        font-weight: 400;
        font-size: 13px;
    }
    p {
        font-size: 16px;
    }
    .buttons{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: 24px;
        padding-top: 16px;

        button{
            width: 152px;
            padding: 8px 0;
            @include icon-and-text-container;
            justify-content: center;
            border-radius: 44px;
            font-weight: 600;
            font-size: 16px;
            &:first-child{
                // border: 1px solid $green;
                color: $green;
            }
            &:last-child{
                background: $green;
                color: #fff;
            }
        }

    }

    .input--link__input {
        width: 300px;
    }

    .modal-add-link__box {
        display: flex;
        flex-direction: column;
        gap: 8px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
        padding: 10px;
        border-radius: 10px;

        &.editing {
            opacity: 0.5;
        }

        h5 {
            font-size: 14px;
            font-weight: 600;
        }
        p {
            font-size: 13px;
        }
    }
}

.loading-link{
    display: flex;
    gap: 4px;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;

    .loading-link__dot{
        width: 4px;
        height: 4px;
        background: $black;
        border-radius: 50%;
    }
    
    .loading-link__dot:nth-child(1){
        animation: loading 1s infinite;
    }
    .loading-link__dot:nth-child(2){
        animation: loading 1s infinite .1s;
    }
    .loading-link__dot:nth-child(3){
        animation: loading 1s infinite .2s;
    }
    @keyframes loading {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
    
}

.modal-body {
    text-align: center;
    align-items: center;
    justify-content: center;

    h4 {
        font-size: 18px;
        font-weight: 600;
        padding-top: 16px;
        strong {
            color: $green;
        }
        span {
            font-size: 18px;
            font-weight: 700;
        }
    }
    p {
        font-size: 14px;
        font-weight: 400;
    }
}
.disclaimer{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    background: #EFE2EE;
    // max-width: 377px;
    padding: 16px;
    border-radius: 10px;

    i{
        color: #9E5498;
        font-size: 24px;
    }
    span {
        color: #9E5498;
    }
}
</style>